import { message } from 'antd'
import { createUser } from '../../../HttpRequests/users'

export default (values) => async () => {

  const data = {
    first_name: values.first_name,
    last_name: values.last_name,
    email: values.email,
    password: values.password,
    type: values.type,
    subcontractor_id: values.type === 'Subcontractor' ? values.subcontractor_id : null,
  }

  const response = await createUser({ data })

  const user = response.data

  message.success('User created')

  return user

}
